import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ButtonsModule, ButtonModule } from '@progress/kendo-angular-buttons';
import { MemberSearchComponent } from './member-search.component';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { GridModule } from '@progress/kendo-angular-grid';
import { PipesModule } from '../pipes/pipes.module';
import { BreadcrumbModule } from 'src/app/shared/breadcrumb/breadcrumb.module';
import { MemberSendSelectionModule } from 'src/app/shared/member-send-selection/member-send-selection.module';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { PatientEditModule } from '../patient-edit/patient-edit.module';

@NgModule({
  imports: [
    CommonModule,
    DialogsModule,
    PopupModule,
    TranslateModule,
    InputsModule,
    ReactiveFormsModule,
    LayoutModule,
    ButtonModule,
    ButtonsModule,
    DropDownsModule,
    GridModule,
    PipesModule,
    BreadcrumbModule,
    MemberSendSelectionModule,
    DateInputsModule,
    PatientEditModule,
  ],
  declarations: [MemberSearchComponent],
  exports: [MemberSearchComponent],
})
export class MemberSearchModule { }
